import {ColorsType} from '../../../../styles';
import {
  AlertIcon,
  CheckCircleIcon,
  InfoIcon,
  WarningIcon,
} from '../../Icons/index.web';

export const iconsByState = {
  alert: AlertIcon,
  warning: WarningIcon,
  info: InfoIcon,
  success: CheckCircleIcon,
};

export const iconColor = (colors: ColorsType) => {
  return {
    alert: colors.alert300,
    warning: colors.warning400,
    info: colors.info300,
    success: colors.success300,
  };
};

export const borderColor = (colors: ColorsType) => {
  return {
    alert: colors.alert200,
    warning: colors.warning300,
    info: colors.info200,
    success: colors.success200,
  };
};

export const bgColor = (colors: ColorsType) => {
  return {
    alert: colors.alert100,
    warning: colors.warning100,
    info: colors.info100,
    success: colors.success100,
  };
};

export const btnColor = {
  alert: 'red',
  warning: 'yellow',
  info: 'blue',
  success: 'green',
};
